/**
 * DevExtreme (esm/viz/core/themes/fluent.js)
 * Version: 23.2.3
 * Build date: Tue Nov 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
var themes = [{
    theme: {
        name: "fluent.blue.light"
    },
    baseThemeName: "material.blue.light"
}, {
    theme: {
        name: "fluent.blue.light.compact"
    },
    baseThemeName: "fluent.blue.light"
}, {
    theme: {
        name: "fluent.blue.dark"
    },
    baseThemeName: "material.blue.dark"
}, {
    theme: {
        name: "fluent.blue.dark.compact"
    },
    baseThemeName: "fluent.blue.dark"
}];
export default themes;
